/**
 * ConfirmationDialog — preset Modal для destructive/important actions.
 * Sprint 2 P0.
 *
 * По UX guide #29: уточняющий вопрос как title, доп. инфа в body,
 * 2 кнопки (Отменить + действие). Default focus на Cancel.
 *
 * Usage:
 *   <ConfirmationDialog
 *     open={open}
 *     onOpenChange={setOpen}
 *     title="Удалить компанию?"
 *     description="Все данные будут потеряны без возможности восстановления."
 *     confirmLabel="Удалить"
 *     onConfirm={handleDelete}
 *     destructive
 *   />
 */
import { Modal, ModalFooter } from './Modal'
import { Button } from './Button'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: string
  confirmLabel?: string
  cancelLabel?: string
  onConfirm: () => void | Promise<void>
  destructive?: boolean
  loading?: boolean
}

export function ConfirmationDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = 'Подтвердить',
  cancelLabel = 'Отменить',
  onConfirm,
  destructive = false,
  loading = false,
}: Props) {
  return (
    <Modal open={open} onOpenChange={onOpenChange} title={title} description={description} size="sm">
      <ModalFooter>
        <Button variant="secondary" onClick={() => onOpenChange(false)} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button
          variant={destructive ? 'destructive' : 'primary'}
          onClick={async () => {
            await onConfirm()
          }}
          loading={loading}
        >
          {confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
